import { z } from 'zod';
import { BatteryRemainingSchema } from '../types/Battery';

export const HubBindIsOkSchema = z.object({
    imei: z.string().nonempty()
});

export type HubBindIsOkMessage = z.infer<typeof HubBindIsOkSchema>;

export const HubSetOnlineSchema = z.object({
    imei: z.string(),
    isOnline: z.boolean()
});

export type HubSetOnlineMessage = z.infer<typeof HubSetOnlineSchema>;

export const HubHbStatusSchema = z.object({
    imei: z.string(),
    isArm: z.boolean(),
    mode: z.int(),
    type: z.int()
});

export type HubHbStatusMessage = z.infer<typeof HubHbStatusSchema>;

export const HubMapPositionSchema = z.object({
    imei: z.string(),
    lat: z.number(),
    lng: z.number(),
    yaw: z.number(),
    isOnline: z.boolean()
});

export type HubMapPositionMessage = z.infer<typeof HubMapPositionSchema>;

export const HubFirmwareProgressSchema = z.object({
    imei: z.string(),
    progress: z.int()
});

export type HubFirmwareProgressMessage = z.infer<typeof HubFirmwareProgressSchema>;

export const HubBaudRateSchema = z.object({
    imei: z.string(),
    baudRate: z.string()
});

export type HubBaudRateMessage = z.infer<typeof HubBaudRateSchema>;

export const HubTelemetrySchema = z.object({
    imei: z.string(),
    batteryRemaining: z.array(BatteryRemainingSchema),
    height: z.number(),
    speed: z.number(),
    sputniksCount: z.int()
});

export type HubTelemetryMessage = z.infer<typeof HubTelemetrySchema>;

export const HubStatusTextSchema = z.object({
    imei: z.string(),
    message: z.string(),
    severity: z.int(),
    time: z.string()
});

export type HubStatusTextMessage = z.infer<typeof HubStatusTextSchema>;
